import type { VAxios } from '../../define/axios/Axios';
import { CanvasInfo, CreateCanvasParams } from '../../entities/cc/canvas.entities';

/**
 * 智绘画布 相关接口
 */
export const createApi = (defHttp: VAxios) => ({
  // 创建画布
  createCanvas: (params: CreateCanvasParams) =>
    defHttp.post({ url: `/aiad/creation/canvas`, params }),

  // 获取画布信息 get
  getCanvas: (id: string) => defHttp.get<CanvasInfo>({ url: `/aiad/creation/canvas/${id}` }),

  // 修改画布信息 put
  updateCanvas: (id: string, params: CreateCanvasParams) =>
    defHttp.put({ url: `/aiad/creation/canvas/${id}`, params }),

  // 删除画布 delete
  deleteCanvas: (id: string) => defHttp.delete({ url: `/aiad/creation/canvas/${id}` }),

  // 修改画布设计信息 put
  updateCanvasDesign: (id: string, params: CreateCanvasParams) =>
    defHttp.put({ url: `/aiad/creation/canvas/${id}/design`, params }),

  // 下载 post
  downloadCanvas: (id: string, params) =>
    defHttp.post({ url: `/aiad/creation/canvas/${id}/download`, params }),

  // 上传文件 post
  uploadFile: (id: string, params) =>
    defHttp.post({ url: `/aiad/creation/canvas/${id}/files`, params }),

  // 提交生成任务 post
  createJob: (id: string, params) =>
    defHttp.post({ url: `/aiad/creation/canvas/${id}/jobs`, params }),

  // 查询单个任务 get
  getJob: (id: string, jobId: string) =>
    defHttp.get({ url: `/aiad/creation/canvas/${id}/jobs/${jobId}` }),

  // 获取快照列表 get
  getSnapshots: (id: string) => defHttp.get({ url: `/aiad/creation/canvas/${id}/snapshots` }),

  // 创建快照 post
  createSnapshot: (id: string, params) =>
    defHttp.post({ url: `/aiad/creation/canvas/${id}/snapshots`, params }),

  // 获取快照详情 get
  getSnapshotInfo: (id: string, snapshotId: string) =>
    defHttp.get({ url: `/aiad/creation/canvas/${id}/snapshots/${snapshotId}` }),

  // 删除快照 delete
  deleteSnapshot: (id: string, snapshotId: string) =>
    defHttp.delete({ url: `/aiad/creation/canvas/${id}/snapshots/${snapshotId}` }),

  // 恢复快照 post
  restoreSnapshot: (id: string, snapshotId: string) =>
    defHttp.post({ url: `/aiad/creation/canvas/${id}/snapshots/${snapshotId}/restore` }),

  // 获取上传信息 get
  getUploadInfo: (id: string) => defHttp.get({ url: `/aiad/creation/canvas/${id}/upload` }),

  // 创建画布工作流信息 post
  createWorkflow: (id: string, params) =>
    defHttp.post({ url: `/aiad/creation/canvas/${id}/workflows`, params }),

  // 获取画布工作流信息 get
  getWorkflow: (id: string, workflowId: string) =>
    defHttp.get({ url: `/aiad/creation/canvas/${id}/workflows/${workflowId}` }),

  // 获取画布是否可用
  getCanvasEnable: () => defHttp.get({ url: '/aiad/creation/canvas/enable' }),

  // 查询所有能力说明信息
  getCanvasIntroductions: () => defHttp.get({ url: '/aiad/creation/canvas/introductions' }),

  // 获取文件头信息
  getDataInfo: (id: string) => defHttp.get({ url: `/aiad/creation/canvas/${id}/lt-data-info` }),

  // 获取文件详情
  getCreationFileDetail: (id: string, fileId: string) =>
    defHttp.get({
      url: `/aiad/creation/canvas/${id}/files/${fileId}`,
    }),

  // 获取上传 work 的sts
  getWorkSTS: (id) => defHttp.get({ url: `/aiad/creation/canvas/${id}/upload` }),

  // 获取草图列表
  getDrafts: (id: string, type: string) =>
    defHttp.get({
      url: `/aiad/creation/canvas/${id}/drafts?type=${type}`,
    }),

  // 获取草图详情
  getDraftDetail: (id: string, draftId: string) =>
    defHttp.get({
      url: `/aiad/creation/canvas/${id}/drafts/${draftId}`,
    }),

  // 新增草图
  addDrafts: (
    id: string,
    params: {
      design?: Record<string, unknown>;
      image?: {
        height?: number;
        size?: number;
        url: string;
        width?: number;
      };
      type?: string;
    },
  ) =>
    defHttp.post({
      url: `/aiad/creation/canvas/${id}/drafts`,
      params,
    }),

  // 修改草图
  updateDrafts: (
    id: string,
    draftId: string,
    params: {
      design?: Record<string, unknown>;
      image?: {
        height?: number;
        size?: number;
        url: string;
        width?: number;
      };
      type?: string;
    },
  ) =>
    defHttp.put({
      url: `/aiad/creation/canvas/${id}/drafts/${draftId}`,
      params,
    }),

  // 删除草图
  removeDrafts: (id: string, draftId: string) =>
    defHttp.delete({
      url: `/aiad/creation/canvas/${id}/drafts/${draftId}`,
    }),

  // 画布反馈
  feedback: (params: { workCreationId: string; content: string }) =>
    defHttp.post({
      url: `/aiad/feedbacks/canvas`,
      params,
    }),
});
